import { Stack } from '@mantine/core';
import React from 'react';

const Frame = ({ ...rest }) => <Stack p={16} {...rest} />;

export default Frame;
